<template>
  <div>
    <!-- Confirmation Modal -->
    <div class="modal fade" :class="{show: showModal, 'd-block': showModal}" tabindex="-1" :style="{display: showModal ? 'block' : 'none'}">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirmation</h5>
            <button type="button" class="btn-close" @click="showModal = false"></button>
          </div>
          <div class="modal-body">
            <p class="my-4">Are you sure you want to remove this consultant from the course?</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showModal = false">Cancel</button>
            <button class="btn btn-danger" @click="confirmRemoval">Confirm</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModal" class="modal-backdrop fade show"></div>

    <!-- Add Consultant Modal -->
    <div class="modal fade" :class="{show: addingconsultant, 'd-block': addingconsultant}" tabindex="-1" :style="{display: addingconsultant ? 'block' : 'none'}">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add consultant to course</h5>
            <button type="button" class="btn-close" @click="addingconsultant = false"></button>
          </div>
          <div class="modal-body">
            <div v-if="alreadyBooked" class="alert alert-warning alert-dismissible fade show">
              This consultant is already booked on this course
              <button type="button" class="btn-close" @click="alreadyBooked = false"></button>
            </div>
            <div class="mb-3">
              <input
                v-model="consultantEMail"
                type="text"
                placeholder="Search e-mail address"
                @input="consultants_filter"
                autocomplete="off"
                class="form-control"
              />
            </div>
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th v-for="field in searchColumns" :key="field.key">{{ field.label }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    v-for="item in searchConsultants" 
                    :key="item.id"
                    @click="consultant_add(item)"
                    style="cursor: pointer;"
                  >
                    <td>{{ item.id }}</td>
                    <td>{{ item.family_name }}</td>
                    <td>{{ item.first_name }}</td>
                    <td>{{ item.email }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="addingconsultant" class="modal-backdrop fade show"></div>

    <Navbar v-show="routemeta.navbar" />
    <Breadcrumb v-show="routemeta.navbar" />
    <div class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 mx-auto my-2">
      <div class="card border-0 px-0 mx-0">
        <div class="card-header bg-white border-0">
          <h2 class="text-primary">Course Bookings</h2>
        </div>
        <div class="card-body mx-0 px-0">
          <div class="mb-3 pb-4">
            <label class="form-label">Course</label>
            <select
              class="form-select"
              v-model="courseId"
              @change="courseconsultants_get"
            >
              <option v-for="option in courseOptions" :key="option.value" :value="option.value">
                {{ option.text }}
              </option>
            </select>
          </div>
          <div 
            v-if="courseId!=0"
            class="card border-0 px-0 mx-0"
          >
            <div class="card-header bg-white border-0">
              <div class="row px-0 mx-0">
                <div class="col-8">
                  Booked consultants
                </div>
                <div class="col-4 text-end">
                  <button
                    class="btn btn-primary"
                    @click="addconsultant"
                  >
                    Add consultant
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body px-0 mx-0">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th v-for="field in consultantColumns" :key="field.key">{{ field.label }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in courseconsultants" :key="item.consultant_id">
                      <td>{{ item.consultant_id }}</td>
                      <td>{{ item.family_name }}</td>
                      <td>{{ item.first_name }}</td>
                      <td>{{ item.email }}</td>
                      <td>{{ item.started_date }}</td>
                      <td class="pt-2">
                        <button 
                          class="btn btn-danger btn-sm" 
                          @click="removingConsultant = item.consultant_id; showModal = true"
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'

const courseConsultantColumns = [
  {
    key: "consultant_id",
    sortable: true,
    label: "ID",
  },
  {
    key: "family_name",
    sortable: true,
    label: "Family name",
  },
  {
    key: "first_name",
    sortable: true,
    label: "First name",
  },
  {
    key: "email",
    sortable: true,
    label: "E-mail",
  },
  {
    key: "started_date",
    sortable: true,
    label: "Booking date",
  },
  {
    key: 'actions',
    sortable: false,
    label: '',
    tdClass: "pt-2",
  }
];

const searchConsultantColumns = [
  {
    key: "id",
    sortable: true,
    label: "ID",
  },
  {
    key: "family_name",
    sortable: true,
    label: "Family name",
  },
  {
    key: "first_name",
    sortable: true,
    label: "First name",
  },
  {
    key: "email",
    sortable: true,
    label: "E-mail",
  },
]
export default {
  name: 'CourseBookings',
  components: {
    Navbar,
    Breadcrumb
  },
  data () {
    return {
      routemeta: this.$route.meta,
      courseOptions: [],
      courseId: 0,
      consultantColumns: courseConsultantColumns,
      courseconsultants: [],
      addingconsultant: false,
      addingconsultantId: 0,
      consultantEMail: '',
      searchConsultants: [],
      searchColumns: searchConsultantColumns,
      alreadyBooked: false,
      showModal: false,
      removingConsultant: 0,
    }
  },
  async created () {
    this.courses_get()
  },
  methods: {
    async confirmRemoval() {
      await this.$store.dispatch('elearningcoursebookings_remove', { courseId: this.courseId, consultantId: this.removingConsultant });
      this.courseconsultants_get();
      this.showModal = false;
    },
    async consultant_remove(item) {
      await this.$store.dispatch('elearningcoursebookings_remove', { courseId: this.courseId, consultantId: item.consultant_id })
      this.courseconsultants_get();
    },
    async addconsultant() {
      this.addingconsultantId = 0;
      this.consultantEMail = '',
      this.addingconsultant = true;
    },
    async saveconsultant() {
    },
    async courses_get () {
      this.loading = true;
      const filter = {
        course_active: {
          operator: '=',
          value: 1
        }
      }
      const res = await this.$store.dispatch('records_readlist', { table_name: 'g_elearning_courses', filter })
      const courseOptions = res.data.result.map( r => {
        return {
            value: r.id,
            text: r.course_name
        }
      })
      this.courseOptions = [
        { value: 0, text: 'Please select a course'},
        ...courseOptions
      ]
    },
    async courseconsultants_get() {
      this.courseconsultants = [];
      const res = await  this.$store.dispatch('elearningcoursebookings_fetch', { course_id: this.courseId })
      this.courseconsultants = res.data.result;
    },
    consultants_filter: _.debounce(function () {
      setTimeout(
        function () {
          this.consultant_search();
        }.bind(this),
        500
      );
    }, 300),
    async consultant_search() {
      const filter = {
        email: {
          operator: ' LIKE ',
          value: `%${this.consultantEMail}%`
        }
      }
      const res = await this.$store.dispatch('records_readlist', { table_name: 'i_user', filter });
      this.searchConsultants = res.data.result;
    },
    async consultant_add(item) {
      const already = this.courseconsultants.find(c => c.consultant_id == item.id)
      if (!already) {
        this.addingconsultant = false;
        await this.$store.dispatch("elearningcoursebookings_add", { courseId: this.courseId, consultantId: item.id })
        this.courseconsultants_get();
      } else {
        this.alreadyBooked = true;
      }
    },
  }
}
</script>
<style>
</style>
